//
// Use as label. Font & size are optimized.
//

import Typography from '@material-ui/core/Typography'

export default Typography